// extracted by mini-css-extract-plugin
module.exports = {"root":"profileForm_root__c36wn","colspan":"profileForm_colspan__ACTCn"};